import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles, Menu, Tooltip } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import ItemCreatorFilter from "../../CustomSelect/ItemCreatorFilter";
import ItemFormatFilter from "../../CustomSelect/ItemFormatFilter";
import { SHOW_FILTERS, STAR_FILTER } from "../../../data/StringConstants";
import CustomButton from "../../CustomButton/CustomButton";
import CustomToggleButton from "../../CustomButton/CustomToggleButton";


const useStyles = makeStyles(() => ({
	formatMenu: {
		"& .MuiList-root": {
			display: "flex",
			flexDirection: "column"
		}
	}
 }));

export default function FilterMenu(props) {
	const classes = useStyles();
	const { availableFilters, selectedFilters, onChange } = props;
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	
	const handleClick = (event) => setAnchorEl(event.currentTarget);

	const handleClose = () => setAnchorEl(null);

	const handleCreatorFilterChange = (value) => onChange({ ...selectedFilters, creator: value });

	const handleFormatFilterChange = (value) => onChange({ ...selectedFilters, format: value});

	const handleStarredFilterChange = (value) => onChange({ ...selectedFilters, starred: value});

	return (
		<Fragment>
			<Tooltip title="Filter" aria-label="Filter">
				<CustomButton
					startIcon={<FilterListIcon />}
					className={classes.toolbarItem} 
					onClick={handleClick}
					size="large"
				>
					{SHOW_FILTERS}
				</CustomButton>
			</Tooltip>
			<Menu
				className={classes.formatMenu}
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
			>
				<ItemCreatorFilter
					className={classes.toolbarItem}
					value={selectedFilters.creator}
					availableFilters={availableFilters.Users}
					onChange={handleCreatorFilterChange}
				/> 
				<ItemFormatFilter
					className={classes.toolbarItem}
					value={selectedFilters.format}
					availableFilters={availableFilters.Formats}
					onChange={handleFormatFilterChange}
				/>
				<CustomToggleButton
					labels={{left: STAR_FILTER.ALL_ITEMS, right: STAR_FILTER.STARRED_ITEMS}}
					value={selectedFilters.starred}
					onChange={handleStarredFilterChange}
				/>
			</Menu>
		</Fragment>
	);
}

FilterMenu.propTypes = {
	availableFilters: PropTypes.object,
	selectedFilters: PropTypes.object,
	onChange: PropTypes.func,
};
